export default "__VITE_ASSET__UI0GGZ4l__"